import React from 'react';
import WhiteBoxProgressIcon from "../../common/primitives/WhiteBoxProgressIcon";

import whiteBox from '../../common/scss/WhiteBox.scss'
import styles from './ComponentTransferDomainBlock.scss';
import TextBox from "../../common/primitives/TextBox";
import textBoxes from "../../common/primitives/TextBox.scss";
import Submit from "../../common/primitives/Submit";
import Label from "../../common/primitives/Label";
import BaseComponent, {AjaxParam} from "../../common/BaseComponent/BaseComponent";
import helpers from '../../common/scss/helpers/_helpers.scss';
import {__t} from '../../common/lang/text-resource';

class ComponentTransferDomainBlock extends BaseComponent {
	error = null;

	onSubmitForm = (event) => {
		event.preventDefault();
		this.error = null;
		const domainName = document.getElementById('transfer_domain_name').value;


		if (domainName === '') {
			this.error = this.messages.EMPTY_DOMAIN_NAME_ERROR;
			this.forceUpdate();
			return false;
		}

		let ajaxParam = new AjaxParam();
		ajaxParam.callbackError = (errorData) => {
			const {componentErrors} = errorData;
			const errorMessage = componentErrors[0];
			this.error = this.messages[errorMessage] || errorMessage;
			this.forceUpdate();
		};

		this.ajaxCall('ActionFormSubmit', {domain_name: domainName}, ajaxParam);
	};


	render() {
		return (
		  <form
			action={''}
			onSubmit={this.onSubmitForm}
			autoComplete={"off"}
			data-layout='text-center'
			className={styles.form}
			data-test="transfer_domain_form">
			  <div className={`${whiteBox.container} ${whiteBox.bigger}`}>
				  <WhiteBoxProgressIcon type={'domains'} bigger={true} forceDisplay={true}/>
				  <div className={styles.innerContainer}>
					  <div className={styles.inputContainer}>
						  <Label htmlFor='transfer_domain_name' text='www.'/>
						  <TextBox
							name='transfer_domain_name'
							id='transfer_domain_name'
							placeholder='mysupersite.com'
							className={`${textBoxes.default} ${textBoxes.thicker}`}
						  />
					  </div>
					  <div>
						  <Submit value={this.props.isMobile ? __t('Трансфер на домейн') : __t('Трансфер')}/>
					  </div>
				  </div>

				  {
					this.error && <div className={helpers.messageContainer} data-layout="margin-top--20"
									   data-test='yellow-error-block-transfer'>
						<div className={helpers.error}>
							{this.error}
						</div>
					</div>
				  }

				  {SHVO.pageLang !== 'en' ?
					<div className={styles.additionalInfo}>
						Повече за условията, при които можете да прехвърлите (трансферирате) домейн към СуперХостинг.БГ,
						можете да научите в{' '}
						<a href="/web-hosting-order-domain-transfer.php"
						   title={'Трансфер на домейн'}>Трансфер на домейн</a>.
					</div>
					:
					<div className={styles.additionalInfo}>
						For more details visit{' '}
						<a href="/web-hosting-order-domain-transfer.php"
						   title={'Domain transfer'}>Domain transfer</a>
						{' '}and our <a href="https://help.superhosting.bg/en/category/domains/transfer"
										title={'help page'}>help page</a>.
					</div>
				  }
			  </div>
		  </form>
		)
	}
}

export default ComponentTransferDomainBlock;